import React, { useState } from "react";

// Logos locales — ficheros en frontend/src/assets/logos/
// Si no existe el logo, se muestran las iniciales automáticamente
const LOGOS = {
  "CHC":          require("../assets/logos/chc.png"),
  "GANA_ENERGIA": require("../assets/logos/gana.png"),
  "IBERDROLA":    require("../assets/logos/iberdrola.png"),
  "ENDESA":       require("../assets/logos/endesa.png"),
  "NATURGY":      require("../assets/logos/naturgy.png"),
  "AION-2.0-TD":  require("../assets/logos/aion.png"),
};

const COLORES = [
  "#f5a623","#00e5a0","#4d9fff","#ff6b6b",
  "#a78bfa","#34d399","#fb923c","#60a5fa",
];

function formatNombre(str) {
  return str
    .replace(/_/g, " ")   // GANA_ENERGIA → GANA ENERGIA
    .replace(/-/g, " ")   // AION-2.0-TD → AION 2.0 TD
    .replace(/\s+/g, " ")
    .trim();
}

function LogoComercializadora({ nombre }) {
  const [error, setError] = useState(false);
  const logoSrc = LOGOS[nombre];
  const iniciales = formatNombre(nombre).split(" ")[0].slice(0, 2).toUpperCase();
  const color = COLORES[nombre.charCodeAt(0) % COLORES.length];

  if (logoSrc && !error) {
    return (
      <div style={{
        width: 72, height: 72, borderRadius: 14, flexShrink: 0,
        background: "#fff", border: "1px solid rgba(255,255,255,.12)",
        display: "flex", alignItems: "center", justifyContent: "center",
        overflow: "hidden", padding: 6,
      }}>
        <img
          src={logoSrc}
          alt={nombre}
          onError={() => setError(true)}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
    );
  }

  return (
    <div style={{
      width: 72, height: 72, borderRadius: 14, flexShrink: 0,
      background: color + "22", border: `1px solid ${color}55`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "var(--display)", fontWeight: 800, fontSize: 20, color,
    }}>
      {iniciales}
    </div>
  );
}

export default function Paso3Resultados({ resultados, onReiniciar, onSeleccionarTarifa }) {
  if (!resultados) return null;
  const { datos_extraidos, ranking } = resultados;

  return (
    <div>
      <div className="resultados-hero">
        <h2>Tu comparativa de tarifas</h2>
        <p>Basada en tu consumo real · Ordenada de menor a mayor coste</p>
      </div>

      {/* Resumen factura */}
      {datos_extraidos && (
        <div className="card" style={{ marginBottom: 24 }}>
          <div className="card-title">Datos de tu factura</div>
          <div className="factura-resumen">
            {datos_extraidos.potencia != null && <FrItem label="Potencia"      val={`${datos_extraidos.potencia} kW`} />}
            {datos_extraidos.dias     != null && <FrItem label="Días"          val={datos_extraidos.dias} />}
            {datos_extraidos.p1_kwh   != null && <FrItem label="P1 Punta"      val={`${datos_extraidos.p1_kwh} kWh`} />}
            {datos_extraidos.p2_kwh   != null && <FrItem label="P2 Llano"      val={`${datos_extraidos.p2_kwh} kWh`} />}
            {datos_extraidos.p3_kwh   != null && <FrItem label="P3 Valle"      val={`${datos_extraidos.p3_kwh} kWh`} />}
            {datos_extraidos.consumo  != null && <FrItem label="Total kWh"     val={`${datos_extraidos.consumo} kWh`} />}
            {datos_extraidos.importe  != null && <FrItem label="Factura actual" val={`${datos_extraidos.importe} €`} accent />}
          </div>
        </div>
      )}

      {/* Ranking */}
      {ranking && ranking.length > 0 ? (
        <>
          <div style={{
            display: "flex", justifyContent: "space-between",
            alignItems: "center", marginBottom: 16,
          }}>
            <div style={{ fontFamily: "var(--display)", fontSize: 20, fontWeight: 800 }}>
              Ranking de tarifas
            </div>
            <div style={{ fontFamily: "var(--mono)", fontSize: 11, color: "var(--text2)" }}>
              {ranking.length} tarifas comparadas
            </div>
          </div>

          {ranking.map((item, i) => {
            const mejor = i === 0;
            const ahorro = item.ahorro ?? 0;
            const nombreComercial = formatNombre(item.comercializadora);
            const nombreTarifa = formatNombre(item.nombre_tarifa);

            return (
              <div key={i} className={`tarifa-card ${mejor ? "mejor" : ""}`}>
                <div className="tarifa-card-header" style={{ cursor: "default" }}>
                  <LogoComercializadora nombre={item.comercializadora} />

                  <div className="tc-info">
                    <div className="tc-comercial" style={{ fontSize: 14 }}>{nombreComercial}</div>
                    <div className="tc-nombre" style={{ fontSize: 19 }}>{nombreTarifa}</div>
                    <div className="tc-badges">
                      {mejor && <span className="badge badge-mejor">✓ Mejor opción</span>}
                      {item.permanencia > 0 && (
                        <span className="badge badge-permanencia">
                          {item.permanencia} meses permanencia
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="tc-totales">
                    {/* Lo que pagarías */}
                    <div style={{ marginBottom: 6 }}>
                      <div style={{ fontFamily: "var(--mono)", fontSize: 9, color: "var(--text3)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 2 }}>
                        Pagarías
                      </div>
                      <div className={`tc-total ${mejor ? "mejor" : ""}`}>
                        {item.coste_estimado?.toFixed(2)} €
                      </div>
                      <div className="tc-periodo">estimado / periodo</div>
                    </div>
                    {/* Separador y ahorro */}
                    {datos_extraidos?.importe != null && (
                      <div style={{
                        borderTop: "1px solid var(--border)", paddingTop: 6, marginTop: 2,
                      }}>
                        <div style={{ fontFamily: "var(--mono)", fontSize: 9, color: "var(--text3)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 2 }}>
                          {ahorro >= 0 ? "Ahorrarías" : "Costaría más"}
                        </div>
                        <div className={`tc-ahorro ${ahorro >= 0 ? "positivo" : "negativo"}`} style={{ fontSize: 15, fontWeight: 700 }}>
                          {ahorro >= 0
                            ? `▼ ${ahorro.toFixed(2)} €`
                            : `▲ ${Math.abs(ahorro).toFixed(2)} €`}
                        </div>
                        <div style={{ fontFamily: "var(--mono)", fontSize: 9, color: "var(--text3)" }}>
                          vs. tu factura actual ({datos_extraidos.importe} €)
                        </div>
                      </div>
                    )}
                    {datos_extraidos?.importe == null && (
                      <div className={`tc-ahorro ${ahorro >= 0 ? "positivo" : "negativo"}`}>
                        {ahorro >= 0
                          ? `▼ Ahorras ${ahorro.toFixed(2)} €`
                          : `▲ ${Math.abs(ahorro).toFixed(2)} € más caro`}
                      </div>
                    )}
                  </div>
                </div>

                <div style={{
                  borderTop: "1px solid var(--border)",
                  padding: "12px 20px",
                  display: "flex", justifyContent: "flex-end",
                }}>
                  <button
                    className="btn btn-primary"
                    style={{ width: "auto", marginTop: 0, padding: "8px 18px", fontSize: 13 }}
                    onClick={() => onSeleccionarTarifa(item)}
                  >
                    ✓ Elegir esta tarifa
                  </button>
                </div>
              </div>
            );
          })}

          {/* Botón asesoramiento */}
          <div style={{
            marginTop: 28, padding: "24px",
            background: "rgba(245,166,35,.06)",
            border: "1px solid rgba(245,166,35,.2)",
            borderRadius: "var(--radius)", textAlign: "center",
          }}>
            <p style={{ color: "var(--text2)", fontSize: 14, marginBottom: 16, lineHeight: 1.6 }}>
              ¿No sabes cuál elegir o quieres que te ayudemos?<br />
              <strong style={{ color: "var(--text)" }}>Nuestro equipo te asesora sin compromiso.</strong>
            </p>
            <button
              className="btn btn-primary"
              style={{ maxWidth: 320, margin: "0 auto" }}
              onClick={() => onSeleccionarTarifa(null)}
            >
              💬 Solicitar asesoramiento
            </button>
          </div>
        </>
      ) : (
        <div style={{ textAlign: "center", padding: "40px 20px", color: "var(--text2)" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
          <p>No se encontraron tarifas para comparar.</p>
        </div>
      )}

      <div className="disclaimer">
        <p>
          <strong>⚠ Aviso importante —</strong>{" "}
          Los costes mostrados son <strong>estimaciones orientativas</strong> basadas en tu potencia
          contratada y consumo por periodos. El coste real puede variar según descuentos, bono social,
          alquiler de contador u otros servicios adicionales.
        </p>
      </div>

      <button className="btn btn-secondary" onClick={onReiniciar} style={{ marginTop: 16 }}>
        ← Nueva comparativa
      </button>
    </div>
  );
}

function FrItem({ label, val, accent }) {
  return (
    <div className="fr-item">
      <div className="fr-label">{label}</div>
      <div className={`fr-val${accent ? " accent" : ""}`}>{val}</div>
    </div>
  );
}
